export const ACTIONS = {
    DIALOG_CONFIRM: 'dialog_confirm',
    DIALOG_SETUP: 'dialog_setup',
    DIALOG_RECOVERY_CODES: 'dialog_recovery_codes',
    DIALOG_BACKUP_PHONE: 'dialog_backup_phone',
    DIALOG_TOTP: 'dialog_totp',

    CONFIRM: 'confirm_password',
    SETUP: 'setup',
    BACKUP_PHONE: 'backup_phone',
    TOTP: 'totp',
    CLOSE: 'close',
};
